module.exports = __webpack_public_path__ + "img/microphone.d050e378.svg";